import { h, Host, } from "@stencil/core";
import { ICON_NAMESPACE } from "../../icons/namespace";
/** Copies the text passed as a child when clicked. */
export class EsCopy {
    constructor() {
        this.iconName = {
            default: [ICON_NAMESPACE, 'copy'],
            thinking: [ICON_NAMESPACE, 'spinner'],
            copied: [ICON_NAMESPACE, 'check'],
            failed: [ICON_NAMESPACE, 'error'],
        };
        this.copyText = async () => {
            clearTimeout(this.timeout);
            this.status = 'thinking';
            try {
                await navigator.clipboard.writeText(this.host.innerText);
                this.status = 'copied';
            }
            catch (error) {
                this.status = 'failed';
            }
            this.timeout = setTimeout(() => {
                this.status = 'default';
            }, 2000);
        };
        this.status = 'default';
    }
    onClick() {
        this.copyText();
    }
    /** Manually triggers the copy of the inner text. */
    async copy() {
        await this.copyText();
    }
    disconnectedCallback() {
        clearTimeout(this.timeout);
    }
    render() {
        return (h(Host, { key: '3d2b9fd76126a1ce900dc421419e20d07b3ee0b9', class: {
                copied: this.status === 'copied',
                failed: this.status === 'failed',
            } }, h("span", { key: '75e84929f9b47dd2b0fef0f18e7107d16996ff61' }, h("slot", { key: '68b89222dbfa9cba96cff29282f3a8e1466298a9' })), h("es-icon", { key: '8d409499ab1c1b4829fba539256e46b134648144', icon: this.iconName[this.status], size: 14 })));
    }
    static get is() { return "es-copy"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-copy.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-copy.css"]
        };
    }
    static get states() {
        return {
            "status": {}
        };
    }
    static get methods() {
        return {
            "copy": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Manually triggers the copy of the inner text.",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "host"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=es-copy.js.map
